<div class="row" style="margin-bottom: 40px;">
  <div class="col-md-8 mx-auto text-center">
    <h1>NOVA SENHA</h1>
  </div>
</div>

<div class="row" *ngIf="isVerify">
  <div class="col-md-8 mx-auto">
    <div class="loader-bubble loader-bubble-primary d-block"></div>
  </div>
</div>

<div class="row" *ngIf="tokenInvalid">
  <div class="col-md-10 mx-auto">
    <ngb-alert [dismissible]="false" class="alert-card col-md-12" [type]="'warning'">
      <span>Seu token expirou, em poucos minutos você receberá em seu e-mail um link para registrar uma nova
        senha.</span>
    </ngb-alert>
  </div>
</div>

<div *ngIf="verifySuccess" class="card o-hidden mb-5"
  [@animate]="{value:'*',params:{y:'120px',opacity:'0',delay:'100ms', duration: '400ms'}}">
  <div class="row">
    <div class="col-md-8 mx-auto">

      <div class="row">
        <div class="col-md-12 text-center">
          Escolha uma nova senha abaixo:
        </div>
      </div>
      <div class="p-4">
        <form [formGroup]="form" (validSubmit)="resetPassword($event)">
          <div class="row" *ngIf="showError">
            <ngb-alert class="alert-card col-md-12" [type]="'danger'" (close)="closeAlert()">
              <span>{{messageError}}</span>
            </ngb-alert>

          </div>

          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <input [type]="showPassword ? 'text' : 'password'" matInput placeholder="SENHA"
                  formControlName="password" [noValidate]="passwordValidators.length > 0">
                <mat-icon matSuffix style="cursor: pointer" (click)="showPassword = !showPassword">visibility</mat-icon>
              </mat-form-field>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <input [type]="showConfirmPassword ? 'text' : 'password'" matInput placeholder="CONFIRMAR SENHA"
                  formControlName="passwordConfirm">
                <mat-icon matSuffix style="cursor: pointer" (click)="showConfirmPassword = !showConfirmPassword">
                  visibility</mat-icon>
              </mat-form-field>
            </div>

            <ngb-alert class="alert col-md-12" [type]="'warning'" [dismissible]="false"
              *ngIf="passwordValidators.length > 0">
              <p>Sua senha precisa ter no mínimo:</p>
              <ul style="list-style: none; padding: 0px">
                <li *ngFor="let item of passwordValidators"
                  [ngClass]="{through: password.value && !password.hasError(item.rule)}">
                  <i class="material-icons">
                    <span *ngIf="!password.value; else validateRule">remove_circle_outline</span>
                    <ng-template #validateRule>
                      <span *ngIf="password.hasError(item.rule); else perfect">remove_circle_outline</span>

                      <ng-template #perfect>
                        <span>check_circle_outline</span>
                      </ng-template>
                    </ng-template>
                  </i> {{item.message}}
                </li>
              </ul>
            </ngb-alert>

          </div>


          <div class="row">
            <div class="col-md-6 mx-auto">
              <btn-loading btnClass="btn-primary btn-rounded btn-block mt-4" [loadingText]="loadingText"
                [loading]="loading$ | async">
                ENVIAR
              </btn-loading>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>